import { EventSegment } from '@fullcalendar/core'
import { ClickAwayListener, Grid } from '@mui/material'
import Box from '@mui/material/Box'
import { t } from 'i18next'
import { ReactElement, ReactNode, useEffect, useRef, useState } from 'react'
import { Root } from 'react-dom/client'
import LocalStorage from 'services/LocalStorage'
import { EventDoc } from 'types/api/changes'
import { LocalStorageKey } from 'types/services/localStorage'
import { eventLengthInDays } from 'utils/event'

import Popup, { PopupInstance } from '../popup/Popup'
import Logger from 'services/Logger'

export interface EventsListPopupProps {
  children?: ReactElement
  events: EventSegment[]
  root?: Root
  date?: Date
  eventDrawer?: (eventSegment: EventSegment) => ReactNode
  instance?: PopupInstance
  onInstance?: (instance: PopupInstance) => void
  onAway?: () => void
}

export function EventsListPopupContent(props: EventsListPopupProps) {
  const listRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = 0
    }
  }, [props.events])

  return (
    <Grid
      ref={listRef}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'flex-start'}
      alignItems={'stretch'}
      style={{
        overflowY: 'auto',

        width: '300px',
        height: 'fit-content',
        maxHeight: '300px',
        pointerEvents: 'all'
      }}
    >
      {props.events.map((event) =>
        props.eventDrawer ? (
          <Box
            key={event.event.id}
            sx={{
              marginTop: '4px',
              width: () => {
                return '100%'
              }
            }}
          >
            {props.eventDrawer(event)}
          </Box>
        ) : (
          <Box
            sx={{
              color: 'black',
              width: '100%'
            }}
            key={event.event.extendedProps.eventModel._id}
          >
            {event.event.extendedProps.eventModel.Text}
          </Box>
        )
      )}
    </Grid>
  )
}
